import * as React from "react";
const WidgetIcon1 = (props) => (
  <svg
    width={59}
    height={59}
    viewBox="0 0 59 59"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x={35.707}
      y={21.9375}
      width={3.625}
      height={3.625}
      rx={1.8125}
      transform="rotate(90 35.707 21.9375)"
      fill="#B1B1B1"
    />
    <rect
      x={26.0405}
      y={21.9375}
      width={3.625}
      height={3.625}
      rx={1.8125}
      transform="rotate(90 26.0405 21.9375)"
      fill="#B1B1B1"
    />
    <path
      d="M28.506 41.3782C30.1441 41.3782 31.4719 42.7061 31.4719 44.3441C31.4719 45.9821 30.1441 47.31 28.506 47.31C26.868 47.31 25.5401 45.9821 25.5401 44.3441C25.5401 42.7061 26.868 41.3782 28.506 41.3782Z"
      fill="#B1B1B1"
    />
    <path
      d="M15.2204 23.0334C15.2204 22.3054 14.6302 21.7152 13.9022 21.7152H13.2431C9.96704 21.7152 7.31128 24.371 7.31128 27.647C7.31128 30.9231 9.96704 33.5788 13.2431 33.5788H13.9022C14.6302 33.5788 15.2204 32.9887 15.2204 32.2607V23.0334Z"
      fill="#B1B1B1"
    />
    <path
      d="M42.9022 23.0334C42.9022 22.3054 43.4924 21.7152 44.2204 21.7152H44.8795C48.1555 21.7152 50.8113 24.371 50.8113 27.647C50.8113 30.9231 48.1555 33.5788 44.8795 33.5788H44.2204C43.4924 33.5788 42.9022 32.9887 42.9022 32.2607V23.0334Z"
      fill="#B1B1B1"
    />
    <path
      d="M15.2203 26.6583V23.6924C15.2203 16.0483 21.4171 9.85151 29.0612 9.85151C36.7054 9.85151 42.9021 16.0483 42.9021 23.6924V26.6583M31.4779 44.344C32.6269 44.3915 33.7915 44.34 34.8754 43.9562C39.6276 42.2733 42.9019 37.7542 42.9019 32.5902M25.5401 44.3441C25.5401 42.706 26.868 41.3782 28.506 41.3782C30.1441 41.3782 31.4719 42.706 31.4719 44.3441C31.4719 45.9821 30.1441 47.31 28.506 47.31C26.868 47.31 25.5401 45.9821 25.5401 44.3441ZM13.9022 33.5788H13.2431C9.96704 33.5788 7.31128 30.9231 7.31128 27.647C7.31128 24.371 9.96704 21.7152 13.2431 21.7152H13.9022C14.6302 21.7152 15.2204 22.3054 15.2204 23.0334V32.2607C15.2204 32.9887 14.6302 33.5788 13.9022 33.5788ZM44.2204 33.5788H44.8795C48.1555 33.5788 50.8113 30.9231 50.8113 27.647C50.8113 24.371 48.1555 21.7152 44.8795 21.7152H44.2204C43.4924 21.7152 42.9022 22.3054 42.9022 23.0334V32.2607C42.9022 32.9887 43.4924 33.5788 44.2204 33.5788Z"
      stroke="#B1B1B1"
      strokeWidth={3.625}
    />
  </svg>
);
export default WidgetIcon1;
